'use strict'

export default class ListController {

  /*@ngInject*/
  constructor ($http, $state, $scope) {
    this.$http = $http
    this.$state = $state
    this.$scope = $scope
    this.versions = [
      {
        value: 1.2,
        name: '1.2'
      },
      {
        value: 1.5,
        name: '1.5'
      },
      {
        value: 2.1,
        name: '2.1'
      },
      {
        value: 2.3,
        name: '2.3'
      },
      {
        value: 2.4,
        name: '2.4'
      },
      {
        value: 2.5,
        name: '2.5'
      },
      {
        value: 2.6,
        name: '2.6'
      },
      {
        value: 2.7,
        name: '2.7'
      },
      {
        value: 2.8,
        name: '2.8'
      },
      {
        value: 2.9,
        name: '2.9'
      },
      {
        value: 3.0,
        name: '3.0'
      }
    ]
    this.version = 2.3
  }

  $onInit () {
    this.$scope.$watch('msListCtrl.version', (c) => {
      if (c !== undefined && c !== null) {
        this.getData()
      }
    })

    this.getData()
  }

  getData () {
    this.$http.get(`/api/myscripts?version=${this.version}`).then(res => {
      this.data = res.data
    })
  }

  delete (id) {
    if (confirm('确定？')) {
      this.$http.delete('api/myscripts/' + id).then(response => {
        this.getData()
      })
    }
  }

}



// WEBPACK FOOTER //
// ./client/app/myscripts/list/list.controller.js